// extracted by mini-css-extract-plugin
module.exports = {"prev":"NavigationButton__prev","next":"NavigationButton__next"};